<template>
  <div class="d-flex flex-wrap align-items-center justify-content-between mb-2" v-if="enable">
    <div class="d-flex align-items-center">
      <slot name="icon"></slot>
      <span class="ml-2 fs-5 bold">{{ name }}</span>
    </div>
    <button
      class="button-social-connect is-danger"
      :class="loading && 'is-loading'"
      @click="disconnect"
      v-if="connected">Disconnect</button>
    <a class="button-social-connect is-success" :href="connectURL" v-else>Connect</a>
  </div>
</template>

<script>
export default {
  name: 'SocialConnectItem',
  props: {
    enable: {
      type: Boolean,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    disconnect: {
      type: Function,
      required: true,
    },
    connectURL: {
      type: String,
      required: true,
    },
    connected: {
      type: Boolean,
      required: true,
    }
  },
}
</script>



// WEBPACK FOOTER //
// SocialConnectItem.vue?057f0540